import { CameraStreamWithDeviceId } from '@/types/camera'
import { Device } from '@/types/device'
import { getDevicesCameras } from './getDeviceAttr'

export const getAugmentedCameras = (
  device: Device
): CameraStreamWithDeviceId[] => {
  const cameras = getDevicesCameras(device)

  return cameras.map((camera) => ({
    ...camera,
    device_id: device.id,
    device_name: device.label,
    is_device_active: device.active
  }))
}
